var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SuccessScreen',{attrs:{"titleKey":"wizard.success.title","messageKey":"wizard.success.created-message","nextRouteName":"home","buttonTextKey":"ask-visit.success.button-text","backNavigationSteps":3}})
}
var staticRenderFns = []

export { render, staticRenderFns }